// import axios from "axios";

// // Base URL da API
// const apiClient = axios.create({
//   baseURL: process.env.VUE_APP_API_URL, // usa a variável do .env
//   headers: {
//     "Content-Type": "application/json",
//   },
//   timeout: 10000,
// });
// // Interceptor de resposta (ex: tratamento global de erros)
// apiClient.interceptors.response.use(
//   (response) => response,
//   (error) => {
//     // Aqui você pode fazer tratamento global de erros
//     // console.error('Erro na resposta da API:', error);
//     return Promise.reject(error);
//   }
// );
// export default apiClient;

// Interceptor de requisição (ex: adicionar token JWT)
// apiClient.interceptors.request.use(
//   (config) => {
//     // Exemplo: adicionar token se existir
//     const token = localStorage.getItem("token");
//     if (token) {
//       config.headers.Authorization = `Bearer ${token}`;
//     }
//     return config;
//   },
//   (error) => {
//     return Promise.reject(error);
//   }
// );

import axios from "axios";
import { useGlobalStore } from "@/store/useGlobalStore";
import router from "@/router";
import { configurarDebugCORS } from "@/utils/corsDebug";
import { tratarErroApi } from "@/utils/erroHandler";

// Usar variável de ambiente definida no .env
const apiBaseURL = process.env.VUE_APP_API_URL || "/api/";

const apiClient = axios.create({
  baseURL: apiBaseURL,
  headers: {
    "Content-Type": "application/json",
  },
  timeout: 30000, // 30 segundos padrão (uploads podem ter timeout específico)
  // 🔑 IMPORTANTE para HttpOnly cookies
  withCredentials: true,
});

// Adicionar Bearer token JWT e CSRF token nas requisições
apiClient.interceptors.request.use((config) => {
  // Adicionar Bearer token JWT se existir
  const jwtToken = localStorage.getItem("token");
  if (jwtToken) {
    config.headers.Authorization = `Bearer ${jwtToken}`;
  }

  // Proteção CSRF
  const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content;
  if (csrfToken) {
    config.headers["X-CSRF-Token"] = csrfToken;
  }

  return config;
});

// Tratamento de erro global
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    const erroNormalizado = tratarErroApi(error);

    // Tratamento de autenticação expirada
    if (erroNormalizado.statusCode === 401) {
      const store = useGlobalStore();
      store.desautenticar();
      // A tela atual é desmontada pelo push abaixo antes de qualquer toast
      // local conseguir aparecer — guarda o motivo pra LoginPage avisar o
      // usuário do porquê ele foi deslogado no meio do uso.
      sessionStorage.setItem("motivo_redirecionamento_login", "sessao_expirada");
      router.push("/login");
    }

    return Promise.reject(erroNormalizado);
  },
);

// Debug de CORS em desenvolvimento
configurarDebugCORS(apiClient);

export default apiClient;
